<template>
    <div class="report-boolean">
        <span class="question" for="">
            <slot name="title"></slot>
            <br />
            <span class="total-answers"> {{ answers.length }} {{ $root.t('forms-report_component-answers') }} </span>
        </span>
        <div class="bar-holder" v-if="hasAnswers">
            <span class="label label-yes">{{ $root.t('forms-report_component-boolean_yes') }} </span>
            <div class="bar">
                <div
                    class="inside-bar yes-bar"
                    v-bind:style="{ width: round(toPercent(yes)) + '%' }"
                >
                    <span class="percent" v-if="toPercent(yes) > 7">
                        {{ round(toPercent(yes)) }}%
                        <span class="tooltip">{{ yes }}</span>
                    </span>
                </div>
                <div
                    class="inside-bar no-bar"
                    v-bind:style="{ width: round(toPercent(no)) + '%' }"
                >
                    <span class="percent" v-if="toPercent(no) > 7">
                        {{ round(toPercent(no)) }}%
                        <span class="tooltip">{{ no }}</span>
                    </span>
                </div>
            </div>
            <span class="label label-no">{{ $root.t('forms-report_component-boolean_no') }}</span>
        </div>
        <span class="no-answers" v-if="!hasAnswers"
            >{{ $root.t('forms-report_component-no_answers') }}</span
        >
    </div>
</template>
<script>
export default {
    props: {
        answers: Array,
    },
    computed: {
        yes() {
            let yes = 0;
            for (let a in this.answers) {
                let answer = this.answers[a];
                let bool = parseInt(answer.valueNumber, 10);
                if (bool) {
                    yes = yes + 1;
                }
            }
            return yes;
        },
        no() {
            let no = 0;
            for (let a in this.answers) {
                let answer = this.answers[a];
                let bool = parseInt(answer.valueNumber, 10);
                if (!bool) {
                    no = no + 1;
                }
            }
            return no;
        },
        total: function () {
            return this.yes + this.no;
        },
        hasAnswers: function () {
            return this.answers.length > 0;
        },
    },
    methods: {
        toPercent: function (value) {
            return (value / this.total) * 100;
        },
        round: function (value, precision) {
            var multiplier = Math.pow(10, precision || 0);
            return Math.round(value * multiplier) / multiplier;
        },
    },
};
</script>
